import React, { Component, Fragment } from 'react';
import * as qs from 'query-string';
import './paymayaCallback.css'


export default class PaymayaCallback extends Component {
    constructor(props){
        super(props);
        this.state={
            status:''
        }
    }
    componentWillMount=()=>{
        console.log(this)
        this.setState({status:this.props.match.params.status})
    }
    render() {
        const {status}=this.state
        return (
            <Fragment>
                <section className="full-width clearfix" style={{marginTop:'20px'}}>
                    <div className="container parent-container" style={{minHeight:445}}>
                    {
                        status=='failure'?
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div id='card' class="animated fadeIn">
                                            <div className='upper-side bg-color-1'>
                                                <i className="fa fa-exclamation-triangle fa-5x"></i>
                                                <h3 id='statusError'>
                                                Payment Failed
                                                </h3>
                                            </div>
                                            <div id='lower-side'>
                                                <p id='message'>
                                                Your payment could not be processed.
                                                </p>
                                                <div id="contBtn" className="bg-color-1" onClick={()=>{
                                            window.location.href='/parent';
                                        }}>Back to dashboard</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>:
                        status=='success'?
                        <div className="row">
                            <div className="col-md-12">
                                <div id='card' class="animated fadeIn">
                                    <div className='upper-side'>
                                        <i className="fa fa-check-circle-o fa-5x"></i>
                                        <h3 id='status'>
                                        Success
                                        </h3>
                                    </div>
                                    <div id='lower-side'>
                                        <p id='message'>
                                        Congratulations, Payment process completed successfully.
                                        </p>
                                        <div id="contBtn" onClick={()=>{
                                            window.location.href='/parent';
                                        }}>Back to dashboard</div>
                                    </div>
                                    </div>
                            </div>
                        </div>: 
                        status=='cancel'?
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div id='card' class="animated fadeIn">
                                            <div className='upper-side bg-color-1'>
                                                <i className="fa fa-exclamation-triangle fa-5x"></i>
                                                <h3 id='statusError'>
                                                Payment Canceled
                                                </h3>
                                            </div>
                                            <div id='lower-side'>
                                                <p id='message'>
                                                Your payment prcess Canceled.
                                                </p>
                                                <div id="contBtn" className="bg-color-1" onClick={()=>{
                                                    window.location.href='/parent';
                                                }}>Back to dashboard</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>:null


                    }
                    </div>
                </section>
                   
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Misc/PaymentModule/paymaya/paymayaCallback.js